import React from 'react';
import { Container, Card } from 'react-bootstrap';
import art1 from "../assets/images/art.png";
import musical from "../assets/images/music_symbal.png";
import drama from "../assets/images/drama.png";
import life from "../assets/images/life.png";
import { Link } from 'react-router-dom';
import arrowLeft from "../assets/images/arrow-left.png";
import ProgramSlider from "../pages/ProgramSlider";

const Explore = () => {
  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-5'>
        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex fs-20 align-items-center mb-0'>
            <Link to='/dashboard'> <img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Explore</h2>
        </div>
        <div className='midtext my-4 fs-12'>
          <p>What excites your child? Whether it's the thrill of acting on stage, the joy of creating art, or the rhythm of music, The Pied Piper has something for everyone.</p>
          <p>Our programs are carefully designed to cater to different interests and age groups, ensuring every child finds their happy place. Here’s what you can explore:</p>
        </div>


        <Card className='mb-3 border-block border-2'>
          <Card.Body className='d-flex align-items-center'>
            <div className='explore_card bg_dark_green d-flex align-items-center justify-content-center'>
              <img src={art1} alt='dance' width={40} />
            </div>
            <div className='explore_content w-100 ps-2'>
              <Card.Title className='mb-1 text-danger fs-12 fw-6'>
                Art & Craft
              </Card.Title>
              <Card.Text className='mb-1 fs-12'>A creative journey with colors, textures, and imagination.</Card.Text>
            </div>
          </Card.Body>
        </Card>

        <Card className='mb-3 border-block border-2'>
          <Card.Body className='d-flex align-items-center'>
            <div className='explore_card bg_dark_yellow d-flex align-items-center justify-content-center'>
              <img src={musical} alt='dance' width={40}/>
            </div>
            <div className='explore_content w-100 ps-2'>
              <Card.Title className='mb-1 text-danger fs-12 fw-6'>
                Music & Dance
              </Card.Title>
              <Card.Text className='mb-1 fs-12'>Expressive programs that combine rhythm and movement.</Card.Text>
            </div>
          </Card.Body>
        </Card>

        <Card className='mb-3 border-block border-2'>
          <Card.Body className='d-flex align-items-center'>
            <div className='explore_card bg_dark_purple d-flex align-items-center justify-content-center'>
              <img src={drama} alt='life' width={40}/>
            </div>
            <div className='explore_content w-100 ps-2'>
              <Card.Title className='mb-1 text-danger fs-12 fw-6'>
                Storytelling & Drama
              </Card.Title>
              <Card.Text className='mb-1 fs-12'>Let your child's inner performer shine!</Card.Text>
            </div>
          </Card.Body>
        </Card>

        <Card className='mb-3  border-block border-2'>
          <Card.Body className='d-flex align-items-center'>
            <div className='explore_card bg_dark_blue d-flex align-items-center justify-content-center'>
              <img src={life} alt='dance' width={40} />
            </div>
            <div className='explore_content w-100 ps-2'>
              <Card.Title className='mb-1 text-danger fs-12 fw-6'>
                Life Skills Workshops
              </Card.Title>
              <Card.Text className='mb-1 fs-12'>Practical, fun sessions to build confidence and curiosity.</Card.Text>
            </div>
          </Card.Body>
        </Card>

        <h6 className='mb-3 fs-12'>Browse through our offerings and find the perfect fit for you little adventurer!</h6>
        <ProgramSlider/>
      </Container>
    </div>
  );
}

export default Explore;
